import { render, staticRenderFns } from "./tencentadsapp-add-or-update.vue?vue&type=template&id=604df9b6&"
import script from "./tencentadsapp-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tencentadsapp-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports